
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M13.536 6.992v-.32c0-.309-.125-.605-.347-.823a1.2 1.2 0 0 0-.838-.341H7.114l-1.4-2.004H2.716c-.315 0-.616.122-.838.34a1.15 1.15 0 0 0-.347.823l.008 7.319v.354c0 .309.125.605.347.823s.523.34.838.34l9.517-.003c.355 0 .69-.163.908-.44l2.15-2.744c.588-.75.05-1.844-.908-1.844H5.281c-.356 0-.691.163-.909.442l-2.72 3.48"}})])
          )
        }
      }
    